import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { DownloadIcon, DownloadButton } from '../../styled';
import Dropdown from './Dropdown';
import { selectIsExportingCSV } from 'store/Manage/selectors';
import { downloadVulns } from 'store/Manage/actions';
import Wrapper from './styled';

const ExportCSV = ({ downloadAction = downloadVulns, showExportAllDataOption = true }) => {
  const wrapperRef = useRef();
  const [showDropdown, setShowDropdown] = useState(false);
  const isExportingCSV = useSelector(selectIsExportingCSV);

  return (
  <Wrapper ref={ wrapperRef }>
      <DownloadButton disabled={ isExportingCSV } title={ isExportingCSV ? 'Exporting CSV' : 'Download' } onClick={ () => setShowDropdown(!showDropdown) }>
        <DownloadIcon />
      </DownloadButton>
      { showDropdown &&
        <Dropdown
          showDropdown={ showDropdown }
          setShowDropdown={ setShowDropdown }
          wrapperRef={ wrapperRef }
          downloadAction={ downloadAction }
          showExportAllDataOption={ showExportAllDataOption }
        />
      }
  </Wrapper>
  );
};

export default ExportCSV;
